import { type ICollectionParams, type ISorting, type IPagination, type IFilter, type IResourceParams, type IDataProviderHelper } from './models';

export class A9DataProviderHelper implements IDataProviderHelper {
    public createRequestParams(collectionParams: ICollectionParams = {}) {
        const params = {};
        try {
            if (collectionParams.filters) {
                this.addFilterParameters(params, collectionParams.filters);
            }
            if (collectionParams.pagination) {
                this.addPaginationParameters(params, collectionParams.pagination);
            }
            if (collectionParams.sorting) {
                this.addSortingParameters(params, collectionParams.sorting);
            }
        } catch (ex) {
            ex.push('request params:');
            ex.push(collectionParams);
            throw ex;
        }
        return params;
    }

    /**
     * Help function for prepare listing request
     */
    public addSortingParameters(params: any, sorting: ISorting[]) {
        if (sorting && sorting.length) {
            params.sort = sorting.map(v => {
                return `${v.sortField || v.field},${v.direction}`;
            });
        }
    }

    /**
     * Help function for prepare listing request
     */
    public addPaginationParameters(params: any, pagination: IPagination) {
        if (pagination) {
            params.page = pagination.number || 0;
            params.size = pagination.size || 0;
        }
    }

    /**
     * Help function for prepare listing request
     */
    public addFilterParameters(params: any, filter: IFilter) {
        if (!filter) {
            return;
        }
        for (const key in filter)
            if (Object.prototype.hasOwnProperty.call(filter, key)) {
                let value = null;
                try {
                    if (Array.isArray(filter[key])) {
                        value = filter[key].map(this.prepareFilterValue);
                    } else {
                        value = this.prepareFilterValue(filter[key]);
                    }
                } catch (ex) {
                    ex.push('in filter key:');
                    ex.push(key);
                    throw ex;
                }
                if (value || value === '' || value === 0) {
                    params[key] = value;
                }
            }
    }

    public urlToPath(url: string): string {
        return url.replace(/{[^}]+}/gi, '{}');
    }

    public buildUrl(urlMask: string, resourceParams: IResourceParams = {}): string {
        let result = urlMask;

        if (resourceParams) {
            Object.keys(resourceParams).forEach(key => {
                const val = resourceParams[key];
                result = result.replace(new RegExp('{' + key + '}', 'g'), val);
            });

            if (resourceParams.id && urlMask.indexOf('{id}') === -1) {
                if (result[result.length - 1] !== '/') {
                    result += '/';
                }
                result += resourceParams.id;
            }
        }

        return result;
    }

    private prepareFilterValue(val: any) {
        if (val === undefined) {
            return;
        }
        if (['string', 'number', 'boolean'].indexOf(typeof val) === -1) {
            throw ['Data Provider Error: Type of filter variable must be string, number or boolean, got value:', val];
        }
        let result = val;
        if (typeof val === 'boolean') {
            result = val ? 'true' : 'false';
        }
        return result;
    }
}
